import axios from '@/axios'

// reports
export async function ListFeedbackReports (page) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports?page=' + page)
  return response.data
}
export async function getFeedbackReport (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports/' + id)
  return response.data.data
}
export async function updateFeedbackReport (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports/' + id, data)
  return response.data.data
}
export async function patchFeedbackReport (id, data) {
  const response = await axios.patch(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports/' + id, data)
  return response.data.data
}
export async function getFeedbackReportComments (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports/' + id + '/comments')
  return response.data
}
export async function createFeedbackReportComment (id, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/feedback-reports/' + id + '/comments', data)
  return response.data.data
}

export default {
  ListFeedbackReports,
  getFeedbackReport,
  updateFeedbackReport,
  patchFeedbackReport,
  getFeedbackReportComments,
  createFeedbackReportComment
}
